var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUpDoubleLine = function SvgArrowUpDoubleLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.5 6.031-5.173 5.173 1.179 1.178L12.5 8.388l3.994 3.994 1.179-1.178zm0 4.708-5.173 5.173 1.179 1.179 3.994-3.995 3.994 3.995 1.179-1.179z"
  })));
};
export default SvgArrowUpDoubleLine;